import { discountNotAvailableCauseSchema } from "./discountNotAvailableCauseSchema";
import { z } from "zod";

export const discountNotAvailableSchema = z.object({
  discountNotAvailableCause: z.lazy(() => discountNotAvailableCauseSchema).optional(),
});

export type DiscountNotAvailable = z.infer<typeof discountNotAvailableSchema>;
